import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';

const DeleteRecipeDialog = ({
  open,
  onClose,
  recipe,
  onDelete
}) => {
  if (!recipe) return null;
  
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: { width: { xs: '95%', sm: '100%' }, mx: 'auto', borderRadius: { xs: 2, sm: 1 } }
      }}
    >
      <DialogTitle sx={{ py: { xs: 2, sm: 1.5 }, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
        Delete Recipe?
      </DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete "{recipe.name}"? This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: { xs: 2, sm: 1.5 } }}>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onDelete} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteRecipeDialog; 